// Datasets simulados usados SOLO por los modales de ayuda (InfoGrafico) para renderizar un
// ejemplo real con el mismo componente de gráfico que usa la pantalla — nunca se pegan a la
// API. Los valores están elegidos para disparar los distintos umbrales de color de cada
// gráfico (verde/ámbar/rojo, sobre/bajo promedio, etc.), no para ser "realistas" en magnitud.

export const MOCK_ESTADOS_TURNO = [
    { estado: 'FINALIZADO', cantidad: 42 },
    { estado: 'ASISTIO', cantidad: 8 },
    { estado: 'NO_ASISTIO', cantidad: 25 },
    { estado: 'CANCELADO', cantidad: 10 },
];

export const MOCK_CANAL_ORIGEN = [
    { nombreCanal: 'Instagram', total: 40, noAsistio: 6 },
    { nombreCanal: 'Facebook', total: 30, noAsistio: 3 },
    { nombreCanal: 'Facebook Bot', total: 25, noAsistio: 10 },
    { nombreCanal: 'Sin clasificar', total: 15, noAsistio: 2 },
];

export const MOCK_VOLUMEN_CONVERSION = [
    { tipoTramite: 'RTI', totalTurnos: 120, conTramite: 9, tasaConversion: 7.5 },
    { tipoTramite: 'JUBILACION', totalTurnos: 60, conTramite: 5, tasaConversion: 8.3 },
    { tipoTramite: 'ART', totalTurnos: 90, conTramite: 3, tasaConversion: 3.3 },
    { tipoTramite: 'REAJUSTE', totalTurnos: 40, conTramite: 1, tasaConversion: 2.5 },
    { tipoTramite: 'GENERAL', totalTurnos: 30, conTramite: 0, tasaConversion: 0 },
];

export const MOCK_DEMANDA_FRANJA = [
    { horario: '08:00', total: 1, bot: 0, manual: 1 },
    { horario: '08:15', total: 2, bot: 0, manual: 2, sobreturnos: 1 },
    { horario: '08:30', total: 2, bot: 1, manual: 1, sobreturnos: 1 },
    { horario: '08:45', total: 1, bot: 0, manual: 1 },
    { horario: '09:00', total: 1, bot: 1, manual: 0 },
    { horario: '09:15', total: 0, bot: 0, manual: 0 },
    { horario: '09:30', total: 1, bot: 0, manual: 1 },
    { horario: '09:45', total: 1, bot: 0, manual: 1 },
];
export const MOCK_CAPACIDAD_FRANJA = 1;

// Con capacidad=1, cada franja "poblada" ya aporta ≥1 turno al denominador de ocupación
// (el backend nunca devuelve una franja con 0 turnos — GROUP BY no emite grupos vacíos),
// así que un bloque solo baja a exactamente 100% cuando cada franja tiene 1 turno justo;
// para bajar de eso hace falta que directamente haya MENOS franjas con datos en el bloque.
export const MOCK_BLOQUES_PORHORARIO = [
    { horario: '08:00', total: 3, bot: 1, manual: 2, atendidos: 3, sobreturnos: 2 },
    { horario: '08:15', total: 2, bot: 0, manual: 2, atendidos: 2, sobreturnos: 1 },
    { horario: '08:30', total: 2, bot: 1, manual: 1, atendidos: 1, sobreturnos: 1 },
    { horario: '08:45', total: 2, bot: 0, manual: 2, atendidos: 2, sobreturnos: 1 },
    { horario: '09:00', total: 1, bot: 0, manual: 1, atendidos: 1, sobreturnos: 0 },
    { horario: '10:00', total: 1, bot: 0, manual: 1, atendidos: 1, sobreturnos: 0 },
    { horario: '10:30', total: 1, bot: 1, manual: 0, atendidos: 1, sobreturnos: 0 },
    { horario: '11:00', total: 1, bot: 0, manual: 1, atendidos: 0, sobreturnos: 0 },
];
export const MOCK_BLOQUES_ESPERA = [
    { horario: '08:00', tiempoEsperaPromedioMinutos: 12 },
    { horario: '08:15', tiempoEsperaPromedioMinutos: 18 },
    { horario: '10:00', tiempoEsperaPromedioMinutos: 8 },
];

export const MOCK_ESPERA_SALA = [
    { horario: '08:00', tiempoEsperaPromedioMinutos: 8 },
    { horario: '08:15', tiempoEsperaPromedioMinutos: 12 },
    { horario: '08:30', tiempoEsperaPromedioMinutos: 22 },
    { horario: '08:45', tiempoEsperaPromedioMinutos: 35 },
    { horario: '09:00', tiempoEsperaPromedioMinutos: 14 },
    { horario: '09:15', tiempoEsperaPromedioMinutos: 6 },
    { horario: '09:30', tiempoEsperaPromedioMinutos: 10 },
    { horario: '09:45', tiempoEsperaPromedioMinutos: 75 }, // franja fuera de escala
    { horario: '10:00', tiempoEsperaPromedioMinutos: 16 },
];

export const MOCK_HEATMAP = [
    { diaSemana: 1, horario: '08:00', total: 2 }, { diaSemana: 1, horario: '09:00', total: 8 },
    { diaSemana: 1, horario: '10:00', total: 5 }, { diaSemana: 2, horario: '09:00', total: 6 },
    { diaSemana: 2, horario: '10:00', total: 9 }, { diaSemana: 3, horario: '09:00', total: 3 },
    { diaSemana: 3, horario: '11:00', total: 4 }, { diaSemana: 4, horario: '09:00', total: 10 },
    { diaSemana: 4, horario: '10:00', total: 7 }, { diaSemana: 5, horario: '09:00', total: 2 },
    { diaSemana: 5, horario: '10:00', total: 3 },
];

export const MOCK_EMBUDO = { agendado: 90, presentaron: 62, conTramite: 23, noAsistio: 20, cancelados: 8 };

export const MOCK_RESULTADO_ATENCION = [
    { resultado: 'Inicia ahora', resultadoLabel: 'Inicia ahora', cantidad: 24, porcentaje: 40 },
    { resultado: 'Carpeta a futuro', resultadoLabel: 'Carpeta a futuro', cantidad: 18, porcentaje: 30 },
    { resultado: 'No viable', resultadoLabel: 'No viable', cantidad: 12, porcentaje: 20 },
    { resultado: 'SIN_CLASIFICAR', resultadoLabel: 'Sin clasificar', cantidad: 6, porcentaje: 10 },
];

export const MOCK_MOTIVOS_NO_AVANCE = [
    { motivo: 'Solo consulta', motivoLabel: 'Solo consulta', cantidad: 20, porcentaje: 44.4 },
    { motivo: 'Falta documentación', motivoLabel: 'Falta documentación', cantidad: 12, porcentaje: 26.7 },
    { motivo: 'No puede pagar moratoria', motivoLabel: 'No puede pagar moratoria', cantidad: 8, porcentaje: 17.8 },
    { motivo: 'Otro', motivoLabel: 'Otro', cantidad: 5, porcentaje: 11.1 },
];

export const MOCK_AUSENTISMO_CANAL = [
    { nombreCanal: 'Instagram', total: 30, noAsistio: 7, tasaAusentismo: 23.3 },
    { nombreCanal: 'Facebook', total: 25, noAsistio: 4, tasaAusentismo: 16.0 },
    { nombreCanal: 'Facebook Bot', total: 20, noAsistio: 2, tasaAusentismo: 10.0 },
];
export const MOCK_PROMEDIO_AUSENTISMO = 15;

export const MOCK_TENDENCIA_MENSUAL = [
    { anio: 2026, mes: 6, total: 200, atendidos: 170, noAsistio: 20, cancelados: 10 },
    { anio: 2026, mes: 7, total: 220, atendidos: 180, noAsistio: 25, cancelados: 15 },
    { anio: 2026, mes: 8, total: 210, atendidos: 165, noAsistio: 30, cancelados: 15 },
];

export const MOCK_CONVERSION_MENSUAL = [
    { anio: 2026, mes: 6, totalTurnos: 200, conTramite: 60, tasaConversion: 30.0 },
    { anio: 2026, mes: 7, totalTurnos: 220, conTramite: 80, tasaConversion: 36.4 },
    { anio: 2026, mes: 8, totalTurnos: 210, conTramite: 90, tasaConversion: 42.9 },
];

// Misma forma que /tendencia-por-tipo: por mes, la lista de resultados del catálogo con turnos.
const mesTendencia = (mes, iniciaAhora, carpetaFuturo, noViable, sinClasificar) => ({
    anio: 2026, mes, total: iniciaAhora + carpetaFuturo + noViable + sinClasificar,
    resultados: [
        { resultado: 'Inicia ahora', resultadoLabel: 'Inicia ahora', cantidad: iniciaAhora },
        { resultado: 'Carpeta a futuro', resultadoLabel: 'Carpeta a futuro', cantidad: carpetaFuturo },
        { resultado: 'No viable', resultadoLabel: 'No viable', cantidad: noViable },
        { resultado: 'SIN_CLASIFICAR', resultadoLabel: 'Sin clasificar', cantidad: sinClasificar },
    ],
});

export const MOCK_TENDENCIA_POR_TIPO = [
    mesTendencia(6, 20, 18, 14, 8),
    mesTendencia(7, 26, 17, 12, 10),
    mesTendencia(8, 24, 16, 10, 8),
];

export const MOCK_TURNOS_POR_DIA = [
    { fecha: '2026-09-01', total: 30, atendidos: 22 },
    { fecha: '2026-09-02', total: 35, atendidos: 20 },
    { fecha: '2026-09-03', total: 17, atendidos: 9 },
    { fecha: '2026-09-04', total: 38, atendidos: 23 },
];

export const MOCK_OPERADORES = [
    { idOperador: 1, operador: 'Rosario', totalAtendidos: 45, tiempoPromedioMinutos: 32, conTramite: 2, tasaConversion: 4.4 },
    { idOperador: 2, operador: 'Agus', totalAtendidos: 38, tiempoPromedioMinutos: 18, conTramite: 4, tasaConversion: 10.5 },
    { idOperador: 3, operador: 'Maxi', totalAtendidos: 30, tiempoPromedioMinutos: 20, conTramite: 2, tasaConversion: 6.7 },
    { idOperador: 4, operador: 'Facu', totalAtendidos: 25, tiempoPromedioMinutos: 14, conTramite: 3, tasaConversion: 12.0 },
];

export const MOCK_VOLUMEN_POR_TIPO = [
    { tipoTramite: 'ART', cantidad: 58, porcentaje: 34.1 },
    { tipoTramite: 'RTI', cantidad: 41, porcentaje: 24.1 },
    { tipoTramite: 'JUBILACION', cantidad: 35, porcentaje: 20.6 },
    { tipoTramite: 'GENERAL', cantidad: 36, porcentaje: 21.2 },
];

export const MOCK_TRAMITES_INICIADOS_TIPO = [
    { nombreTipoTramite: 'RTI', cantidad: 22, porcentaje: 36.7 },
    { nombreTipoTramite: 'ART', cantidad: 18, porcentaje: 30.0 },
    { nombreTipoTramite: 'JUBILACION', cantidad: 12, porcentaje: 20.0 },
    { nombreTipoTramite: 'PLAN_PAGO', cantidad: 8, porcentaje: 13.3 },
];
